import {Outlet} from 'react-router-dom';

import {CardBox, ClassicMuiNavTabs} from '@shared/components';
import {
  ROUTE__SETTINGS_PAYMENT_METHODS,
  ROUTE__SETTINGS_PAYMENT_METHODS__PAYOUTS,
} from '@shared/constants';
import {Header} from '@widgets/common';

import {COLOR__WHITE} from '@/theme/colors';

const tabs = [
  {route: ROUTE__SETTINGS_PAYMENT_METHODS, label: 'Deposits'},
  {route: ROUTE__SETTINGS_PAYMENT_METHODS__PAYOUTS, label: 'Payouts'},
];

export const PaymentMethodsPage = () => {
  return (
    <>
      <Header title="Payment methods" isBackButtonShown={false} mb={2} />

      <CardBox bgcolor={COLOR__WHITE}>
        <ClassicMuiNavTabs tabs={tabs} sx={{mb: 3}} />

        <Outlet />
      </CardBox>
    </>
  );
};
